import { Autocomplete, Box, TextField } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';

/** 정해진 목록에서만 고르는 편집 셀(W.UOM·V.UOM). 모양은 UOM 칸의 선택 셀과 같다. */
export default function OptionSelectCell({ id, field, value, options }) {
    const apiRef = useGridApiContext();
    return (
        <Box sx={{ width: '100%', px: 0.5 }}>
            <Autocomplete
                size="small"
                options={options}
                value={options.includes(value) ? value : null}
                openOnFocus
                autoHighlight
                disableClearable
                onChange={(_, picked) => {
                    apiRef.current.setEditCellValue({ id, field, value: picked });
                    apiRef.current.stopCellEditMode({ id, field });
                }}
                renderInput={(params) => <TextField {...params} autoFocus placeholder={value || ''} sx={{ '& input': { fontSize: 11 } }} />}
                ListboxProps={{ style: { fontSize: 11 } }}
                slotProps={{ popper: { placement: 'bottom-start', style: { width: 'max-content', minWidth: 80 } } }}
            />
        </Box>
    );
}
